import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import classNames from "classnames";
import DropdownItem from "../DropdownItem";

var Component = function Component(_ref) {
  var getClassName = _ref.getClassName,
      index = _ref.index,
      items = _ref.items,
      placement = _ref.dropdownContentPlacement,
      style = _ref.style,
      renderFilter = _ref.renderFilter,
      renderItem = _ref.renderItem,
      forwardedRef = _ref.forwardedRef,
      isTypeaheadMode = _ref.isTypeaheadMode,
      onCollapse = _ref.onCollapse,
      filterInputId = _ref.filterInputId,
      maxVisibleItems = _ref.maxVisibleItems,
      maxListHeight = _ref.maxListHeight,
      value = _ref.value,
      onBlur = _ref.onDropdownBlur,
      onItemClicked = _ref.onItemClicked,
      withCheckmark = _ref.withCheckmark,
      setListMaxHeight = _ref.setListMaxHeight,
      getRefs = _ref.getRefs,
      maxWidth = _ref.maxWidth,
      withPortal = _ref.withPortal;

  var _getRefs = getRefs(),
      itemsListContainerRef = _getRefs.itemsListContainerRef,
      selectedLinkRef = _getRefs.selectedLinkRef,
      filterContainerRef = _getRefs.filterContainerRef;

  var isLinks = items.every(function (item) {
    return !item.value && item.href;
  });

  var a11yListProps = _objectSpread(_objectSpread({}, !isLinks && {
    role: "listbox"
  }), {}, {
    tabIndex: isLinks ? -1 : 0
  });

  var getListStyles = function getListStyles() {
    if (maxVisibleItems) {
      return {
        maxHeight: maxListHeight
      };
    } // eslint-disable-next-line no-undefined


    return undefined;
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-placement": placement,
    ref: forwardedRef,
    style: _objectSpread(_objectSpread({}, style), {}, {
      maxWidth: maxWidth
    }),
    className: getClassName({
      descendantName: "listWrapper",
      modifiers: classNames([!withPortal && "positioned"], placement !== null && placement !== void 0 && placement.includes("top") ? "placementTop" : "placementBottom")
    })
  }, renderFilter && !isTypeaheadMode && renderFilter(onCollapse, filterContainerRef, filterInputId), /*#__PURE__*/React.createElement("ul", _extends({
    ref: itemsListContainerRef,
    className: getClassName({
      descendantName: "items",
      modifiers: classNames({
        scroll: maxVisibleItems,
        links: isLinks
      })
    })
  }, a11yListProps, {
    style: getListStyles()
  }), items.map(function (item, itemIndex) {
    var isSelected = value === item.value || Boolean(isTypeaheadMode && value === item.label); // measure height only for first item to prevent perfomance issues & only if scroll needed

    var shouldMeasureHeight = itemIndex === 0 && maxVisibleItems;
    var itemProps = {
      getClassName: getClassName,
      getItemHeight: shouldMeasureHeight ? setListMaxHeight : // eslint-disable-next-line no-undefined
      undefined,
      isFocused: index === itemIndex,
      isSelected: isSelected,
      item: item,
      linkRef: isSelected && item.href ? selectedLinkRef : // eslint-disable-next-line no-undefined
      undefined,
      onBlur: onBlur,
      onItemClicked: onItemClicked,
      withCheckmark: withCheckmark
    };
    return renderItem ? renderItem(itemProps, itemIndex) : /*#__PURE__*/React.createElement(DropdownItem, _extends({}, itemProps, {
      key: item.label
    }));
  })));
};

Component.displayName = "DropdownContent";

function forwardRef(props, ref) {
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = "ForwardedRef(".concat(Component.displayName, ")");
export default /*#__PURE__*/React.forwardRef(forwardRef);